<template>

    <div>
        <el-dialog title="位置信息" width="60%" :visible="locationTreeDialogVisible" @close="btnCloseHandler" center>
            <el-form>
                <el-row>
                    <location-tree ref="locationTreeRef" :roomId="roomId" @selectedNode="selectedNodeHandler"></location-tree>
                </el-row>
                <el-row style="text-align: center">
                    <el-button center="true" type="primary" @click="btnConfirmHandler">确 定</el-button>
                    <el-button center @click="btnCloseHandler">关 闭</el-button>
                </el-row>
            </el-form>
        </el-dialog>
    </div>

</template>

<script>

    import locationTree from "@/components/dcim/locationTree";

    export default {
        name: "locationTreeDialog",

        components: {
            locationTree,
        },

        props: {
            locationTreeDialogVisible: {
                type: Boolean,
                default: false,
            },

            roomId: {
                type: Number,
            }
        },

        data() {
            return {
                selectedNode: null,
            }
        },

        methods: {
            btnConfirmHandler() {
                this.$emit("afterSelectedNode", this.selectedNode);
            },

            btnCloseHandler() {
                this.$emit('update:locationTreeDialogVisible', false);
            },

            selectedNodeHandler(selectedNode) {
                this.selectedNode = selectedNode;
            },
        }

    }
</script>

<style scoped>

</style>